

import Socials from '../../components/socials.vue';
import {authApi} from '../../src/Api';
import {PropType} from 'vue';
import AuthModel from '../../src/Model';
import {AuthAppService} from '../../src/AuthAppService';
import { SendCodePageSetting } from "modules/auth/src/Event/SendCodePageSetting";

export default {
    components: {
        Socials
    },
    props: {
        service: {
            type: Object as PropType<AuthAppService>,
        },
        modelValue: {
            type: Object as PropType<AuthModel>,
            required: true,
        },
        onNext: {
            type: Function as PropType<(AuthModel) => Promise<void>>,
            required: true,
        },
    },
    emits: ['back'],
    data() {
        return {
            code: '',
            error: null,
            disabled: false,
            inputError: null,
            timeToLife: null,
            currentTime: null,
            timer: null,
            loading: false,
            ttlShowSendSmsMethod: 20,
            sendingSms: false,
        };
    },
    watch: {
        currentTime(time) {
            if (time === 0) {
                this.stopTimer();
            }
        },
    },
    mounted() {
        this.$refs.code.focus();
        this.currentTime = this.modelValue.sendCodePageSetting?.ttl || 60;
        this.startTimer();
    },
    unmounted() {
        this.stopTimer();
    },
    methods: {
        noSymbols: function(event) {
            if (!event.key.match(/[0-9]/g)) {
                event.preventDefault();
            }
        },
        backToLogin() {
            this.$emit('back');
        },
        async onSendCode() {
            this.loading = true;
            const result = await authApi.sendCode(this.modelValue.hash, this.code);
            const response = result.response();
            if (response?.redirectUrl) {
                await authApi.goRedirect(response.redirectUrl);
                return;
            }
            if (result.error()) {
                this.inputError = result.error().message;
                this.disabled = result.error().disabled;
                this.error = result.error().description;
                this.loading = false;
                return;
            }
            this.modelValue.isConfirmed = response.isConfirmed;
            await this.onNext(this.modelValue);
        },
        clear() {
            this.inputError = null;
            this.error = null;
        },
        async onSendSms() {
            this.sendingSms = true;
            this.disabled = true;
            try {
                const result = await authApi.sendSms(this.modelValue.hash);
                if (result.error()) {
                    this.inputError = result.error().message;
                    this.disabled = result.error().disabled;
                    this.error = result.error().description;
                    this.loading = false;
                    return;
                }
                if (result.isOk()) {
                    const login = result.response();
                    this.modelValue.sendCodePageSetting = new SendCodePageSetting(login.sendCodeText, login.ttl, login.hash);
                    this.currentTime = this.modelValue.sendCodePageSetting?.ttl || 60;
                    this.ttlShowSendSmsMethod = 20;
                    this.startTimer();
                }
            } finally {
                this.sendingSms = false;
                this.disabled = false;
            }
        },
        startTimer() {
            this.stopTimer();
            this.timer = setInterval(() => {
                this.ttlShowSendSmsMethod--;
                this.currentTime -= 1;
            }, 1000);
        },
        stopTimer() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        },
        showOAuth() {
            return this.service.configuration.isEsia || this.service.configuration.isSocials;
        },
    },
};
